import { Link } from "react-router-dom";
import { Plus, FileText } from "lucide-react";
import { assetUrl } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ p }) {
  const { add } = useCart();
  return (
    <div data-testid={`product-card-${p.product_key}`} className="card-hover bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col">
      <Link to={`/product/${p.product_key}`} className="block relative aspect-[3/4] bg-gradient-to-br from-[#3B1F6E] to-[#0A0F1D] overflow-hidden">
        {p.cover_url ? (
          <img src={assetUrl(p.cover_url)} alt={p.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><FileText className="w-10 h-10 text-white/30" /></div>
        )}
        <span className="absolute top-3 left-3 bg-[#D97706] text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full">{p.category}</span>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex gap-1.5 mb-2 flex-wrap">
          {p.formats?.slice(0, 3).map((f) => (
            <span key={f} className="text-[10px] font-semibold text-[#3B1F6E] bg-[#3B1F6E]/8 px-2 py-0.5 rounded-full">{f}</span>
          ))}
        </div>
        <Link to={`/product/${p.product_key}`} className="font-serif-display text-xl font-semibold text-[#0A0F1D] leading-snug hover:text-[#3B1F6E] transition-colors">{p.title}</Link>
        {p.subtitle && <p className="text-sm text-slate-500 mt-1 line-clamp-2">{p.subtitle}</p>}
        <div className="mt-auto pt-4 flex items-center justify-between">
          <span className="font-ui text-lg font-bold text-[#2E1065]">${p.price.toFixed(2)}</span>
          <button data-testid={`add-to-cart-${p.product_key}`}
            onClick={() => { add(p); toast.success(`${p.title} added to cart`); }}
            className="flex items-center gap-1.5 bg-[#3B1F6E] hover:bg-[#2E1065] text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors">
            <Plus className="w-4 h-4" /> Add
          </button>
        </div>
      </div>
    </div>
  );
}
